<template>
  <div>
    <div class="row vehicle-alerts">
      <div class="col-12" v-if="groupedWarnings">
        <AlertMessage
            type="warning"
            class="alert-message"
            :message="groupedWarnings.message"
            :link="groupedWarnings.link"
        />
      </div>

      <div class="col-12" v-if="groupedDangers">
        <AlertMessage
            type="danger"
            class="alert-message"
            :message="groupedDangers.message"
            :link="groupedDangers.link"
        />
      </div>

    </div>

    <div class="row">
      <div class="col-md-3" v-for="card in cards" :key="card.key">
        <DashboardCard
            :to="card.to"
            :value="data[card.key]"
            :label="card.label"
            :icon="card.icon"
            :iconType="card.iconType"
            :variant="card.variant"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DashboardCard from "../layouts/components/DashboardCard.vue";
import AlertMessage from "../layouts/components/Alert";
import axios from "axios";

export default {
  components: {DashboardCard, AlertMessage},
  data() {
    return {
      data: {
        vehicle: 0,
        center: 0,
        device: 0,
        fine: 0,
        licensing: 0,
        units: 0,
        refueling: 0,
        users: 0,
        professionals: 0,
        autoInsurance: 0,
        vehicle_free: 0,
        vehicle_courtyard: 0,
        vehicle_occurrence: 0,
        vehicle_under_maintenance: 0,
        unassigned_devices: 0,
        unassigned_vehicles: 0,
      },
      alerts: [],
      cards: [
        {
          key: "users",
          label: "Users",
          icon: "UsersIcon",
          iconType: "feather",
          variant: "light-primary",
          to: "/users"
        },
        {
          key: "center",
          label: "Centrals",
          icon: "fas fa-building",
          iconType: "fontawesome",
          variant: "light-warning",
          to: "/centers"
        },
        {
          key: "units",
          label: "Units",
          icon: "TagIcon",
          iconType: "feather",
          variant: "light-success",
          to: "/units"
        },
        // {
        //   key: "professionals",
        //   label: "Professionals",
        //   icon: "fas fa-stethoscope",
        //   iconType: "fontawesome",
        //   variant: "light-danger",
        //   to: "/professionals"
        // },
        // {
        //   key: "autoInsurance",
        //   label: "Insurance",
        //   icon: "ShieldIcon",
        //   iconType: "feather",
        //   variant: "light-success",
        //   to: "/insurances"
        // },
        // {
        //   key: "fine",
        //   label: "Fines",
        //   icon: "FileTextIcon",
        //   iconType: "feather",
        //   variant: "light-danger",
        //   to: "/fines"
        // },
        {
          key: "device",
          label: "Devices",
          icon: "CpuIcon",
          iconType: "feather",
          variant: "light-info",
          to: "/devices"
        },
        {
          key: "unassigned_devices",
          label: "Unassigned Devices",
          icon: "CpuIcon",
          iconType: "feather",
          variant: "light-danger",
          to: "/devices"
        },
        // {
        //   key: "licensing",
        //   label: "Licensing",
        //   icon: "CreditCardIcon",
        //   iconType: "feather",
        //   variant: "light-info",
        //   to: "/licensings"
        // },
        // {
        //   key: "refueling",
        //   label: "Supplies",
        //   icon: "DollarSignIcon",
        //   iconType: "feather",
        //   variant: "light-warning",
        //   to: "/refuelings"
        // },
        {
          key: "vehicle",
          label: "Vehicles",
          icon: "TruckIcon",
          iconType: "feather",
          variant: "light-info",
          to: "/vehicles"
        },
        {
          key: "unassigned_vehicles",
          label: "Unassigned Vehicles",
          icon: "TruckIcon",
          iconType: "feather",
          variant: "light-danger",
          to: "/vehicles"
        },
        // {
        //   key: "vehicle_free",
        //   label: "Vehicles Free",
        //   icon: "TruckIcon",
        //   iconType: "feather",
        //   variant: "light-secondary",
        //   to: "/vehicles"
        // },
        // {
        //   key: "vehicle_courtyard",
        //   label: "Vehicles in the Yard",
        //   icon: "TruckIcon",
        //   iconType: "feather",
        //   variant: "light-info",
        //   to: "/vehicles"
        // },
        // {
        //   key: "vehicle_occurrence",
        //   label: "Vehicles in Occurrence",
        //   icon: "TruckIcon",
        //   iconType: "feather",
        //   variant: "light-danger",
        //   to: "/vehicles"
        // },
        // {
        //   key: "vehicle_under_maintenance",
        //   label: "Vehicles Under maintenance",
        //   icon: "TruckIcon",
        //   iconType: "feather",
        //   variant: "light-warning",
        //   to: "/vehicles"
        // },
      ],
    };
  },
  computed: {
    groupedWarnings() {
      const warnings = this.alerts.filter(alert => alert.status === 'nearing_expiration');
      if (!warnings.length) return null;

      const ids = warnings.map(alert => alert.vehicle_id).join(', ');
      return {
        message: `${this.$t('Vehicles')} ${ids} ${this.$t('have vehicle licensing expiring this month. Please check')}`,
        link: '/licensings'
      };
    },
    groupedDangers() {
      const dangers = this.alerts.filter(alert => alert.status === 'expired');
      if (!dangers.length) return null;

      const ids = dangers.map(alert => alert.vehicle_id).join(', ');
      return {
        message: `${this.$t('Vehicles')} ${ids} ${this.$t('have expired vehicle licensing. Please check')}`,
        link: '/licensings'
      };
    }
  },
  methods: {
    getDashboard() {
      const api = this.$store.state.api + "companies/report";
      axios.post(api)
          .then(response => {
            if (response.data) {
              this.data = {...this.data, ...response.data};
            }
          })
          .catch(error => {
            this.$error(error);
          });
    },
    async getVehicleLicensingAlerts() {
      const api = this.$store.state.api + "vehicle_licensing_alerts?paginated=false";
      try {
        const response = await axios.get(api);
        if (response.data && response.data.data) {
          this.alerts = response.data.data;
        } else {
          this.alerts = [];
        }
      } catch (error) {
        this.$error(error);
        this.alerts = [];
      }
    }
  },
  mounted() {
    this.getDashboard();
    this.getVehicleLicensingAlerts();
  }
};
</script>


<style scoped>
.vehicle-alerts .alert-message {
  font-size: 1.1rem;
  padding: 1.2rem;
  border-radius: 0.5rem;
}
</style>